import React from "react";

export default function BrandMark({
  alt = "DDDP logo",
  className = "",
  imageClassName = "",
}) {
  const wrapperClassName = `inline-flex items-center justify-center overflow-hidden ${className}`.trim();
  const iconClassName = `h-full w-full object-contain ${imageClassName}`.trim();

  return (
    <span className={wrapperClassName}>
      <img src="/favicon.ico" alt={alt} className={iconClassName} />
    </span>
  );
}
